import { getCookie } from "../utils/storage.util";

export function authInterceptor(axiosInstance: any) {
  axiosInstance.interceptors.request.use((request: any) => {
    const token = getCookie("jwt-token");
    const isLoggedIn = !!token;

    if (isLoggedIn) {
      request.headers!["Authorization"] = `Bearer ${token}`;
    }

    return request;
  });
}

export function unauthorizedInterceptor(axiosInstance: any) {
  axiosInstance.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      return Promise.reject(error);
    },
  );
}
